<template>
    <div class="vue-horizontal-scroller">
        <div class="inner">
          <div class="row">
            <div class="col-12 mx-auto">
              <slot></slot>

              <div class="scroller-content-wrapper">
                <perfect-scrollbar>
                  <div class="category-item" v-for="item in items">
                    <div class="inner">
                        <img :src="item.thumbnailSrc" alt="">
                        <h3>{{ item.name }}</h3>
                      <a :href="item.termUrl" class="btn btn-secondary">Bekijk deze producten</a>
                    </div>
                  </div>
                </perfect-scrollbar>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HorizontalScroll",

    props: {
        items: {
            required: true
        }
    }
}
</script>